export const calculateFileSize = (size: number): string => {
  const kilobytes = size / 1024;

  if (kilobytes >= 1024) {
    return `${(kilobytes / 1024).toFixed(1)} MB`;
  }

  if (kilobytes < 1) {
    return `${size.toFixed(1)} B`;
  }

  return `${kilobytes.toFixed(1)} kB`;
};
